import React from "react";

/**
 * Standardized StatCard component for Dashboard & Management views
 * @param {string} title - Card metric title
 * @param {string|number} value - Main stat value
 * @param {string} subtitle - Subtitle/context (e.g. "+1 ce mois")
 * @param {React.ElementType} icon - Lucide Icon component
 * @param {string} iconBg - CSS color for icon background
 * @param {string} iconColor - CSS color for icon
 * @param {function} onClick - Click handler if card is interactive
 */
const StatCard = ({
  title,
  value,
  subtitle = null,
  icon: Icon = null,
  iconBg = "var(--primary-light)",
  iconColor = "var(--primary)",
  onClick = null
}) => {
  return (
    <div
      onClick={onClick}
      className={`ui-card ${onClick ? "ui-card-interactive" : ""}`}
      style={{
        padding: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: onClick ? "pointer" : "default"
      }}
    >
      <div>
        <span style={{
          fontSize: "0.85rem",
          fontWeight: "600",
          color: "var(--text-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.03em"
        }}>
          {title}
        </span>
        <div style={{
          fontSize: "1.8rem",
          fontWeight: "800",
          color: "var(--text-main)",
          lineHeight: "1.2",
          marginTop: "6px"
        }}>
          {value}
        </div>
        {subtitle && (
          <div style={{
            fontSize: "0.8rem",
            fontWeight: "500",
            color: "var(--text-muted)",
            marginTop: "6px",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          }}>
            {subtitle}
          </div>
        )}
      </div>

      {Icon && (
        <div style={{
          width: "48px",
          height: "48px",
          borderRadius: "var(--radius-md)",
          backgroundColor: iconBg,
          color: iconColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}>
          <Icon size={24} />
        </div>
      )}
    </div>
  );
};

export default StatCard;
